/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceGroupScheduledMaintenanceConfigDto } from "./DeviceGroupScheduledMaintenanceConfigDto";
import {
    DeviceGroupScheduledMaintenanceConfigDtoFromJSON,
    DeviceGroupScheduledMaintenanceConfigDtoFromJSONTyped,
    DeviceGroupScheduledMaintenanceConfigDtoToJSON,
} from "./DeviceGroupScheduledMaintenanceConfigDto";
import type { ContactDto } from "./ContactDto";
import {
    ContactDtoFromJSON,
    ContactDtoFromJSONTyped,
    ContactDtoToJSON,
} from "./ContactDto";
import type { AddressDto } from "./AddressDto";
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
} from "./AddressDto";
import type { DeviceGroupServiceModelConfigDto } from "./DeviceGroupServiceModelConfigDto";
import {
    DeviceGroupServiceModelConfigDtoFromJSON,
    DeviceGroupServiceModelConfigDtoFromJSONTyped,
    DeviceGroupServiceModelConfigDtoToJSON,
} from "./DeviceGroupServiceModelConfigDto";

/**
 *
 * @export
 * @interface DeviceGroupDto
 */
export interface DeviceGroupDto {
    /**
     * Group tag. Unique, read only. Equal to the OrganisationId when DeviceGroupType=Organisation (or OrganisationGroupId when DeviceGroupType=OrganisationGroup). Otherwise, may be auto generated from Type_Organisation_Name field
     * @type {string}
     * @memberof DeviceGroupDto
     */
    deviceGroupTag?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceGroupDto
     */
    deviceGroupType?: DeviceGroupDtoDeviceGroupTypeEnum;
    /**
     * Free text name, eg 'Head office carpark'.
     * @type {string}
     * @memberof DeviceGroupDto
     */
    deviceGroupName?: string;
    /**
     * The owner of this group. Not null, unless DeviceGroupType==OrganisationGroup|EndUser*
     * @type {string}
     * @memberof DeviceGroupDto
     */
    organisationId?: string;
    /**
     * The id of the owning organisation's parent organisation, if any. Only populated for DeviceGroupType=Organisation groups whose organisation has a parent.
     * @type {string}
     * @memberof DeviceGroupDto
     */
    parentOrganisationId?: string;
    /**
     * The name of the owning organisation's parent organisation, if any. Only populated for DeviceGroupType=Organisation groups whose organisation has a parent.
     * @type {string}
     * @memberof DeviceGroupDto
     */
    parentOrganisationName?: string;
    /**
     * The owner of this group. Null, unless DeviceGroupType==OrganisationGroup
     * @type {string}
     * @memberof DeviceGroupDto
     */
    organisationGroupId?: string;
    /**
     * The user that created the group. Usually null for DeviceGroupType==Organisation and OrganisationGroup.
     * @type {number}
     * @memberof DeviceGroupDto
     */
    createdByUserAccountId?: number;
    /**
     *
     * @type {Date}
     * @memberof DeviceGroupDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceGroupDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {string}
     * @memberof DeviceGroupDto
     */
    internalNotes?: string;
    /**
     *
     * @type {AddressDto}
     * @memberof DeviceGroupDto
     */
    deviceGroupAddress?: AddressDto;
    /**
     *
     * @type {string}
     * @memberof DeviceGroupDto
     */
    billingProvider?: DeviceGroupDtoBillingProviderEnum;
    /**
     *
     * @type {string}
     * @memberof DeviceGroupDto
     */
    billingCurrencyCode?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceGroupDto
     */
    billingDescription?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceGroupDto
     */
    billingSiteHostPaymentInfo?: string;
    /**
     * The id of the subscription product in the Provider's system. If not set, defaults to StripeProviderOptions.SubscriptionPriceId
     * @type {string}
     * @memberof DeviceGroupDto
     */
    billingSubscriptionSku?: string;
    /**
     * The price of the subscription (for display only)
     * @type {number}
     * @memberof DeviceGroupDto
     */
    billingSubscriptionPrice?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceGroupDto
     */
    billingType?: DeviceGroupDtoBillingTypeEnum;
    /**
     *
     * @type {DeviceGroupServiceModelConfigDto}
     * @memberof DeviceGroupDto
     */
    serviceModelConfig?: DeviceGroupServiceModelConfigDto;
    /**
     *
     * @type {DeviceGroupScheduledMaintenanceConfigDto}
     * @memberof DeviceGroupDto
     */
    scheduledMaintenanceConfig?: DeviceGroupScheduledMaintenanceConfigDto;
    /**
     *
     * @type {Array<ContactDto>}
     * @memberof DeviceGroupDto
     */
    contacts?: Array<ContactDto>;
    /**
     *
     * @type {boolean}
     * @memberof DeviceGroupDto
     */
    isFavourite?: boolean;
    /**
     * Count of non-virtual devices.
     * @type {number}
     * @memberof DeviceGroupDto
     */
    devicesCount?: number;
}

/**
 * @export
 */
export const DeviceGroupDtoDeviceGroupTypeEnum = {
    OrganisationGroup: "OrganisationGroup",
    Organisation: "Organisation",
    Site: "Site",
    Logical: "Logical",
    Arbitrary: "Arbitrary",
    EndUserOwner: "EndUserOwner",
    EndUserSecondary: "EndUserSecondary",
    Billing: "Billing",
    ServiceModel: "ServiceModel",
    ScheduledMaintenance: "ScheduledMaintenance",
} as const;
export type DeviceGroupDtoDeviceGroupTypeEnum =
    (typeof DeviceGroupDtoDeviceGroupTypeEnum)[keyof typeof DeviceGroupDtoDeviceGroupTypeEnum];

/**
 * @export
 */
export const DeviceGroupDtoBillingProviderEnum = {
    Unknown: "Unknown",
    StripeSandbox: "StripeSandbox",
    Stripe: "Stripe",
} as const;
export type DeviceGroupDtoBillingProviderEnum =
    (typeof DeviceGroupDtoBillingProviderEnum)[keyof typeof DeviceGroupDtoBillingProviderEnum];

/**
 * @export
 */
export const DeviceGroupDtoBillingTypeEnum = {
    Private: "Private",
    Shared: "Shared",
} as const;
export type DeviceGroupDtoBillingTypeEnum =
    (typeof DeviceGroupDtoBillingTypeEnum)[keyof typeof DeviceGroupDtoBillingTypeEnum];

/**
 * Check if a given object implements the DeviceGroupDto interface.
 */
export function instanceOfDeviceGroupDto(
    value: object,
): value is DeviceGroupDto {
    return true;
}

export function DeviceGroupDtoFromJSON(json: any): DeviceGroupDto {
    return DeviceGroupDtoFromJSONTyped(json, false);
}

export function DeviceGroupDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceGroupDto {
    if (json == null) {
        return json;
    }
    return {
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        deviceGroupType:
            json["deviceGroupType"] == null
                ? undefined
                : json["deviceGroupType"],
        deviceGroupName:
            json["deviceGroupName"] == null
                ? undefined
                : json["deviceGroupName"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        parentOrganisationId:
            json["parentOrganisationId"] == null
                ? undefined
                : json["parentOrganisationId"],
        parentOrganisationName:
            json["parentOrganisationName"] == null
                ? undefined
                : json["parentOrganisationName"],
        organisationGroupId:
            json["organisationGroupId"] == null
                ? undefined
                : json["organisationGroupId"],
        createdByUserAccountId:
            json["createdByUserAccountId"] == null
                ? undefined
                : json["createdByUserAccountId"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        internalNotes:
            json["internalNotes"] == null ? undefined : json["internalNotes"],
        deviceGroupAddress:
            json["deviceGroupAddress"] == null
                ? undefined
                : AddressDtoFromJSON(json["deviceGroupAddress"]),
        billingProvider:
            json["billingProvider"] == null
                ? undefined
                : json["billingProvider"],
        billingCurrencyCode:
            json["billingCurrencyCode"] == null
                ? undefined
                : json["billingCurrencyCode"],
        billingDescription:
            json["billingDescription"] == null
                ? undefined
                : json["billingDescription"],
        billingSiteHostPaymentInfo:
            json["billingSiteHostPaymentInfo"] == null
                ? undefined
                : json["billingSiteHostPaymentInfo"],
        billingSubscriptionSku:
            json["billingSubscriptionSku"] == null
                ? undefined
                : json["billingSubscriptionSku"],
        billingSubscriptionPrice:
            json["billingSubscriptionPrice"] == null
                ? undefined
                : json["billingSubscriptionPrice"],
        billingType:
            json["billingType"] == null ? undefined : json["billingType"],
        serviceModelConfig:
            json["serviceModelConfig"] == null
                ? undefined
                : DeviceGroupServiceModelConfigDtoFromJSON(
                      json["serviceModelConfig"],
                  ),
        scheduledMaintenanceConfig:
            json["scheduledMaintenanceConfig"] == null
                ? undefined
                : DeviceGroupScheduledMaintenanceConfigDtoFromJSON(
                      json["scheduledMaintenanceConfig"],
                  ),
        contacts:
            json["contacts"] == null
                ? undefined
                : (json["contacts"] as Array<any>).map(ContactDtoFromJSON),
        isFavourite:
            json["isFavourite"] == null ? undefined : json["isFavourite"],
        devicesCount:
            json["devicesCount"] == null ? undefined : json["devicesCount"],
    };
}

export function DeviceGroupDtoToJSON(value?: DeviceGroupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceGroupTag: value["deviceGroupTag"],
        deviceGroupType: value["deviceGroupType"],
        deviceGroupName: value["deviceGroupName"],
        organisationId: value["organisationId"],
        parentOrganisationId: value["parentOrganisationId"],
        parentOrganisationName: value["parentOrganisationName"],
        organisationGroupId: value["organisationGroupId"],
        createdByUserAccountId: value["createdByUserAccountId"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        internalNotes: value["internalNotes"],
        deviceGroupAddress: AddressDtoToJSON(value["deviceGroupAddress"]),
        billingProvider: value["billingProvider"],
        billingCurrencyCode: value["billingCurrencyCode"],
        billingDescription: value["billingDescription"],
        billingSiteHostPaymentInfo: value["billingSiteHostPaymentInfo"],
        billingSubscriptionSku: value["billingSubscriptionSku"],
        billingSubscriptionPrice: value["billingSubscriptionPrice"],
        billingType: value["billingType"],
        serviceModelConfig: DeviceGroupServiceModelConfigDtoToJSON(
            value["serviceModelConfig"],
        ),
        scheduledMaintenanceConfig:
            DeviceGroupScheduledMaintenanceConfigDtoToJSON(
                value["scheduledMaintenanceConfig"],
            ),
        contacts:
            value["contacts"] == null
                ? undefined
                : (value["contacts"] as Array<any>).map(ContactDtoToJSON),
        isFavourite: value["isFavourite"],
        devicesCount: value["devicesCount"],
    };
}
